import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { decryptCrmData } from '../actionCreators';
import { parseSessionDataAndPopulateFormFields } from '../useBrowserMessages/useBrowserMessagesHelpers';
import updateCrmData from './useCrmAutoFill.helpers';

const useCrmAutoFill = () => {
  const { decryptedData } = useSelector((store) => store.crmAutoFill);
  const { urlAliasComponentIdMaps, mappedQuestionIdToComponentId } =
    useSelector((store) => store.dataMappings);
  const { pageUrl, countryCode, formId } = useSelector(
    (store) => store.formConfig
  );
  const { iFrameId } = useSelector((store) => store.optionalFormConfig);
  const components = useSelector((store) => store.components);
  const dispatch = useDispatch();

  const getUrl = () => {
    if (pageUrl) {
      return pageUrl;
    }

    return window.location !== window.parent.location
      ? document.referrer
      : document.location.href;
  };

  const getCgid = () => {
    if (!getUrl()) return; // if invalid url
    const url = new URL(getUrl());
    const urlParams = url.searchParams;

    if (urlParams.has('cgid')) {
      return urlParams.get('cgid');
    }
  };

  useEffect(() => {
    if (!iFrameId) return;

    const cgid = getCgid();
    if (cgid) {
      dispatch(
        decryptCrmData({
          payload: cgid,
        })
      );
    }

    if (pageUrl) {
      const url = new URL(pageUrl);
      const urlParams = url.searchParams;
      urlParams.forEach((value, key) => {
        if (!urlAliasComponentIdMaps[key]) {
          return;
        }

        const componentId = urlAliasComponentIdMaps[key];
        const componentQuestionText =
          components[`component_${componentId}`].component.text;

        parseSessionDataAndPopulateFormFields({
          sessionData: {
            [componentQuestionText]: value,
          },
          components,
          dispatch,
          iFrameId,
          countryCode,
          formId,
        });
      });
    }
  }, [pageUrl, iFrameId]);

  useEffect(() => {
    if (decryptedData) {
      updateCrmData({
        decryptedData,
        mappedQuestionIdToComponentId,
        urlAliasComponentIdMaps,
        dispatch,
        countryCode,
        iFrameId,
        components,
        formId,
      });
    }
  }, [decryptedData, iFrameId]);
};

export default useCrmAutoFill;
